import { render, staticRenderFns } from "./ShowDocumentsTab.vue?vue&type=template&id=34ad26aa&scoped=true"
import script from "./ShowDocumentsTab.vue?vue&type=script&lang=js"
export * from "./ShowDocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./ShowDocumentsTab.vue?vue&type=style&index=0&id=34ad26aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad26aa",
  null
  
)

export default component.exports